/**
 * @module markdown
 * @description Утилиты для преобразования Markdown в безопасный HTML.
 *
 * @requires marked - Парсинг Markdown в HTML
 * @requires dompurify - Санитизация HTML для безопасности
 */
import DOMPurify from 'dompurify';
import { marked } from 'marked';

/**
 * Преобразует Markdown текст в безопасный HTML.
 *
 * @param md - Markdown текст для преобразования. Пустая строка обрабатывается корректно
 * @returns Безопасный HTML, очищенный от потенциально опасных элементов (script, iframe, event handlers и т.д.)
 */
export function renderMarkdownToSafeHtml(md: string): string {
    const raw = marked.parse(md);
    const html = typeof raw === 'string' ? raw : '';
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}

window.renderMarkdownToSafeHtml = renderMarkdownToSafeHtml;
